import { requestHandler } from "../lib/utils/network-client";

export function getMetadataList(params = {}) {
  const query = new URLSearchParams(params).toString();
  return requestHandler(`/metadata${query ? `?${query}` : ""}`);
}

export function createMetadata(payload) {
  return requestHandler("/metadata", {
    method: "POST",
    body: payload
  });
}

export function updateMetadata(id, payload) {
  return requestHandler(`/metadata/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deleteMetadata(id) {
  return requestHandler(`/metadata/${id}`, {
    method: "DELETE"
  });
}
